import { SettingsPlaceholder } from "@/pages/settings/settings-placeholder";

export function LegalNoticesSettingsPage() {
  return (
    <SettingsPlaceholder
      title="Legal Notices"
      description="Terms of Service, Privacy Policy, DPA. Deferred to Phase 2."
      eta="Later"
    />
  );
}
